import React, { Component } from 'react';
import { ColorRing } from 'react-loader-spinner';

const Loader = () => {
  

    return (
      <div className="main_loader">
        <ColorRing
          visible={true}
          height="40"
          width="40"
          ariaLabel="blocks-loading"
          wrapperStyle={{}}
          wrapperclassName="blocks-wrapper"
          colors={['var(--app-text)']}
        />
      </div>
    );

}

export default Loader;
